/* WK tile color swatches: hover/tap a dot to swap the tile photo + link. */
      (function () {
        if (window.wkSwInit) return;
        window.wkSwInit = true;
        function pick(btn) {
          var card = btn.closest('li.wk-card, li.wks-card');
          if (!card) return;
          var img = card.querySelector('.wk-card__img--main, .wks-card__img--main');
          if (img && btn.dataset.src) {
            img.removeAttribute('loading');
            if (btn.dataset.srcset) img.srcset = btn.dataset.srcset;
            img.src = btn.dataset.src;
          }
          var link = card.querySelector('a.wk-card__link, a.wks-card__link');
          if (link && btn.dataset.url) link.href = btn.dataset.url;
          card.classList.add('wk-sw-picked');
          card.querySelectorAll('.wk-sw__dot').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        }
        document.addEventListener('click', function (e) {
          var btn = e.target.closest && e.target.closest('.wk-sw__dot');
          if (btn) { e.preventDefault(); pick(btn); }
        });
        document.addEventListener('mouseover', function (e) {
          if (!window.matchMedia('(hover: hover)').matches) return;
          var btn = e.target.closest && e.target.closest('.wk-sw__dot');
          if (btn) pick(btn);
        });
      })();
